.icon {
  width:25px;
  height: 18px;
  stroke: var(--color-black-30);

  &.active {
    stroke: black;
  }
}
